import { router, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import {
  NativeSelect,
  NativeSelectOption,
} from "@/components/ui/native-select";
import { companySelectionPath } from "@/routes";

export function CompanySwitcher() {
  const { auth } = usePage().props;
  const { t } = useTranslation();
  if (!auth.companies || auth.companies.length < 2) return null;

  return (
    <NativeSelect
      className="w-full text-card-foreground [&_select]:cursor-pointer"
      aria-label={t("companies.switch")}
      value={auth.account?.id || ""}
      onChange={(event) => {
        router.patch(companySelectionPath(), {
          account_id: event.target.value,
        });
      }}
    >
      {auth.companies.map((company) => (
        <NativeSelectOption key={company.id} value={company.id}>
          {company.name}
        </NativeSelectOption>
      ))}
    </NativeSelect>
  );
}
